import styled from 'styled-components'

import Container from '../basic-components/Container'
import logo from './mapclick_logo.jpg';

const Logo = styled.img`
  flex: none;
  display: block;
  margin: 0 auto;
`
const Paragraph = styled.p`
  flex: none;
  text-align: center;
  margin-block-start: 1rem;
  margin-block-end: 1rem;
`
const Disclaimer = styled.div`
  flex: 1;
  /*margin: 1em;*/
  padding: 0.5em 1em;
  background-color: #ffffff;
  overflow: auto;
`
const ButtonContainer = styled.div`
  flex: none;
  text-align: center;
  padding: 0.5rem 0.5rem;
`
const Button = styled.button`
  border: 0.2rem solid darkgrey;
  border-radius: 0.8rem;
  padding: 0.3em 0.5em;
  background-color: white;
`

export default function DisclaimerPage({ onClick }) {
  return (
    <Container style={{pointerEvents: 'all'}}>
      <Logo src={logo} alt="logo" />
      <Paragraph>
        Disclaimer (scroll to view all)
      </Paragraph>
      <Disclaimer>
        MapClick is Johnston County's online GIS mapping system and is provided as
        a public service. The layers of information presented are public records
        including deeds, plats, property tax information, etc., as well as information
        from other agencies such as local, state, or federal agencies. A review of GIS
        data does not take the place of primary source review and independent verification
        of information.
        <br/><br/>
        Johnston County makes no warranty, representation, or guarantee as to the accuracy
        of the data presented, and Johnston County assumes no liability for any errors
        or omissions. Further, neither Johnston County nor the website provider guarantee
        that the website or the data presented will be available to users without
        interruption. Such data is subject to modification.
        <br/><br/>
      </Disclaimer>
      <Paragraph>
        By clicking "OK", I acknowledge and accept the above limitations.
      </Paragraph>
      <ButtonContainer>
        <Button onClick={onClick}>OK</Button>
      </ButtonContainer>
    </Container>
  );
}
